"use client";

import { useState, useEffect } from "react";
import axios from "axios";
import { useParams, useNavigate, Link } from "react-router-dom";
import Select from "react-select";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AddItem = () => {
  const { orderId, orderDate } = useParams();
  const navigate = useNavigate();

  const [items, setItems] = useState([]);
  const [products, setProducts] = useState([]);
  const [colors, setColors] = useState([]);
  const [success, setSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    fetchItems();
    fetchProducts();
    fetchColors();
  }, []);

  const fetchItems = async () => {
    const res = await axios.get(
      `https://logicx.premierlam.com/api/pixel-get-items/${orderId}`,
      { headers: { authorization: localStorage.getItem("accessToken") } }
    );

    const updatedExisting = res.data.data.map((i) => ({
      product_master_code: i.product_code,
      product_name: i.product_name,
      product_category: i.product_category,
      product_material: i.product_material,
      product_color: i.product_color,
      product_sku: i.product_sku,
      product_link: i.product_link,
      selling_price: i.selling_price,
      unit_price: i.unit_price,
      hsn_code: i.hsn_code,
      amount: i.amount,
      gstAmount: i.gstAmount || i.taxes || "",
      discount: i.discount,
      total_amount: i.total_amount,
      item_original_name: i.item_original_name || "",
      vendor_image: i.vendor_image || null,
      get_quantity: i.qty || "",
      item_details: i.item_details || "",
      submitted: true,
    }));


    setItems([...updatedExisting, blankItem()]);
  };
  const blankItem = () => ({
     id: crypto.randomUUID(), 
    product_master_code: "",
    product_name: "",
    product_category: "",
    product_material: "",
    product_color: "",
    product_sku: "",
    product_link: "",
    selling_price: "",
    unit_price: "",
    hsn_code: "",
    amount: "",
    gstAmount: "",
    discount: "",
    total_amount: "",
    item_original_name: "",
    vendor_image: null,
    get_quantity: "",
    item_details: "",
    submitted: false,
      isAdding: false, 
  });


  const fetchProducts = async () => {
    const res = await axios.get(`https://logicx.premierlam.com/api/get-pixel-products`, {
      headers: { authorization: localStorage.getItem("accessToken") },
    });
    setProducts(res.data.data);
  };

  const fetchColors = async () => {
    const res = await axios.get(`https://logicx.premierlam.com/api/pixel-get-product-colors`, {
      headers: { authorization: localStorage.getItem("accessToken") },
    });
    setColors(res.data.data);
  };

  const productOptions = products.map((p) => ({
    value: p.product_code,
    label: `${p.product_code} - ${p.product_name}`,
  }));

  const colorOptions = colors.map((c) => ({
    value: c.product_color,
    label: c.product_color,
  }));

  const updateItem = (index, updates) => {
    setItems((prev) => {
      const newItems = [...prev];
      newItems[index] = { ...newItems[index], ...updates };
      return newItems;
    });
  };

  const handleProductSelect = (index, selected) => {
    const selectedProduct = products.find((p) => p.product_code === selected?.value);

    updateItem(index, {
      product_master_code: selectedProduct.product_code,
      product_name: selectedProduct.product_name,
      product_category: selectedProduct.category_name,
      product_material: selectedProduct.product_material,
    });
  };

  const submitItem = async (index, isFinishSubmit = false) => {
    if (items[index].submitted) return true;

    setIsSubmitting(true);

    try {
      const formData = new FormData();
      formData.append("order_id", orderId);
      formData.append("order_date", orderDate);

      Object.entries({
        product_master_code: items[index].product_master_code,
        product_name: items[index].product_name,
        product_material: items[index].product_material,
        product_category: items[index].product_category,
        product_color: items[index].product_color,
        product_sku: items[index].product_sku,
        product_link: items[index].product_link,
        selling_price: items[index].selling_price,
        unit_price: items[index].unit_price,
        hsn_code: String(items[index].hsn_code || ""),
        amount: items[index].amount,
        gstAmount: items[index].gstAmount, // mapped correctly from taxes
        discount: items[index].discount,
        total_amount: items[index].total_amount,

        item_original_name: items[index].item_original_name,
        get_quantity: items[index].get_quantity,
        item_details: items[index].item_details,
      }).forEach(([key, value]) => {
        formData.append(key, value == null ? "" : value);
      });

      if (items[index].vendor_image instanceof File) {
        formData.append("image", items[index].vendor_image);
      }

      await axios.post(
        "https://logicx.premierlam.com/api/pixel-add-item",
        formData,
        {
          headers: {
            authorization: localStorage.getItem("accessToken"),
           
          },
        }
      );



      setItems((prev) => {
        const updated = [...prev];
        updated[index].submitted = true;
        updated[index].isAdding = false; 
        if (!isFinishSubmit) {
          updated.push(blankItem());
        }
        return updated;
      });

      setSuccess(true);
      toast.success("Item added successfully!");
      setTimeout(() => setSuccess(false), 1500);

      return true;

    } catch (err) {
      console.log("ITEM ADD ERROR:", err.response?.data);
      toast.error(err.response?.data?.message || "Failed to add item");

      return false;
    }
    finally {
      setIsSubmitting(false);
    }
  };

  const handleAdd = async (index) => {
     if (items[index].isAdding || items[index].submitted) return; 
    // await submitItem(index, false);
      updateItem(index, { isAdding: true });

  const success = await submitItem(index, false);

  // if API failed, re-enable button
  if (!success) {
    updateItem(index, { isAdding: false });
  }
  };

  const handleFinish = async () => {
    const lastIndex = items.length - 1;
    if (!items[lastIndex].submitted) {
      const result = await submitItem(lastIndex, true);
      if (!result) return;
    }

    setSuccess(true);
    toast.success("All items added!");

    setTimeout(() => navigate("/all-order"), 2000);
  };

  return (
    <> <ToastContainer position="top-right" autoClose={3000} />
    <div className="p-6 bg-gray-50 min-h-screen">
      <div className="max-w-5xl mx-auto bg-white p-6 rounded-lg shadow-sm border">

        <div className="flex justify-between mb-6">
          <h1 className="text-2xl font-semibold text-gray-700">Add Items</h1>
          <Link to="/all-order" className="bg-gray-800 hover:bg-gray-900 text-white px-4 py-2 rounded-md">
            Back to Orders
          </Link>
        </div>

        {success && (
          <div className="mb-3 p-3 bg-green-100 border border-green-300 rounded text-green-700">
            Item added successfully!
          </div>
        )}

        <div className="mb-6 grid grid-cols-2 gap-6">
          <div>
            <label className="block text-sm font-medium text-gray-600 mb-1">Order ID</label>
            <input value={orderId} readOnly className="w-full px-3 py-2 bg-gray-100 border rounded" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-600 mb-1">Order Date</label>
            <input value={orderDate} readOnly className="w-full px-3 py-2 bg-gray-100 border rounded" />
          </div>
        </div>

        {items.map((item, index) => (
          <div key={item.id} className="border rounded-lg p-4 mb-6 bg-gray-50">
            {!item.submitted && <p className="text-gray-700 mb-3 font-medium">Add Item {index + 1}</p>}

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

              <div className="w-full">
                <label className="block text-sm font-medium text-gray-600 mb-1">Product Code *</label>
                <Select
                  options={productOptions}
                  placeholder="Select Product"
                  value={
                    productOptions.find(opt => opt.value === item.product_master_code) || null
                  }
                  isDisabled={item.submitted}
                  onChange={(selected) => handleProductSelect(index, selected)}
                  className="w-full"
                />
              </div>

              <div className="w-full">
                <label className="block text-sm font-medium text-gray-600 mb-1">Product Name</label>
                <input
                  readOnly
                  value={item.product_name}
                  className="w-full px-3 py-2 border bg-gray-100 rounded"
                />
              </div>

              <div className="w-full">
                <label className="block text-sm font-medium text-gray-600 mb-1">Category</label>
                <input
                  readOnly
                  value={item.product_category}
                  className="w-full px-3 py-2 border bg-gray-100 rounded"
                />
              </div>

              <div className="w-full">
                <label className="block text-sm font-medium text-gray-600 mb-1">Material</label>
                <input
                  readOnly
                  value={item.product_material}
                  className="w-full px-3 py-2 border bg-gray-100 rounded"
                />
              </div>

              <div className="w-full">
                <label className="block text-sm font-medium text-gray-600 mb-1">Color *</label>
                <Select
                  options={colorOptions}
                  isDisabled={item.submitted}
                  value={
                    colorOptions.find(opt => opt.value === item.product_color) || null
                  }
                  placeholder="Select Color"
                  onChange={(opt) => updateItem(index, { product_color: opt?.value })}
                  className="w-full"
                />
              </div>

              <div className="w-full">
                <label className="block text-sm font-medium text-gray-600 mb-1">SKU</label>
                <input
                  type="text"
                  disabled={item.submitted}
                  value={item.product_sku}
                  placeholder="SKU"
                  className="w-full px-3 py-2 border rounded"
                  onChange={(e) => updateItem(index, { product_sku: e.target.value })}
                />
              </div>

              <div className="w-full">
                <label className="block text-sm font-medium text-gray-600 mb-1">Product Link</label>
                <input
                  type="text"
                  disabled={item.submitted}
                  value={item.product_link}
                  placeholder="Product Link"
                  className="w-full px-3 py-2 border rounded"
                  onChange={(e) => updateItem(index, { product_link: e.target.value })}
                />
              </div>

              <div className="w-full">
                <label className="block text-sm font-medium text-gray-600 mb-1">Selling Price *</label>
                <input
                  type="text"
                  disabled={item.submitted}
                  value={item.selling_price}
                  placeholder="Selling Price"
                  className="w-full px-3 py-2 border rounded"
                  onChange={(e) => updateItem(index, { selling_price: e.target.value })}
                />
              </div>
              <div className="w-full">
                <label className="block text-sm font-medium text-gray-600 mb-1">Unit Price *</label>
                <input
                  type="text"
                  disabled={item.submitted}
                  value={item.unit_price}
                  placeholder="Unit Price"
                  className="w-full px-3 py-2 border rounded"
                  onChange={(e) => updateItem(index, { unit_price: e.target.value })}
                />
              </div>

              <div className="w-full">
                <label className="block text-sm font-medium text-gray-600 mb-1">HSN Code *</label>
                <input
                  type="text"
                  disabled={item.submitted}
                  value={item.hsn_code}
                  placeholder="HSN Code"
                  className="w-full px-3 py-2 border rounded"
                  onChange={(e) => updateItem(index, { hsn_code: e.target.value })}
                />
              </div>

              <div className="w-full">
                <label className="block text-sm font-medium text-gray-600 mb-1">Amount *</label>
                <input
                  type="text"
                  disabled={item.submitted}
                  value={item.amount}
                  placeholder="Amount"
                  className="w-full px-3 py-2 border rounded"
                  onChange={(e) => updateItem(index, { amount: e.target.value })}
                />
              </div>

              <div className="w-full">
                <label className="block text-sm font-medium text-gray-600 mb-1">GST Amount *</label>
                <input
                  type="text"
                  disabled={item.submitted}
                  value={item.gstAmount}
                  placeholder="GST Amount"
                  className="w-full px-3 py-2 border rounded"
                  onChange={(e) => updateItem(index, { gstAmount: e.target.value })}
                />
              </div>

              <div className="w-full">
                <label className="block text-sm font-medium text-gray-600 mb-1">Discount *</label>
                <input
                  type="text"
                  disabled={item.submitted}
                  value={item.discount}
                  placeholder="Discount"
                  className="w-full px-3 py-2 border rounded"
                  onChange={(e) => updateItem(index, { discount: e.target.value })}
                />
              </div>

              <div className="w-full">
                <label className="block text-sm font-medium text-gray-600 mb-1">Total Amount *</label>
                <input
                  type="text"
                  disabled={item.submitted}
                  value={item.total_amount}
                  placeholder="Total Amount"
                  className="w-full px-3 py-2 border rounded"
                  onChange={(e) => updateItem(index, { total_amount: e.target.value })}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600 mb-1">Original Name</label>
                <input
                  type="text"
                  disabled={item.submitted}
                  value={item.item_original_name}
                  className="w-full px-3 py-2 border rounded"
                  onChange={(e) => updateItem(index, { item_original_name: e.target.value })}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-600 mb-1">Quantity *</label>
                <input
                  type="number"
                  disabled={item.submitted}
                  value={item.get_quantity}
                  className="w-full px-3 py-2 border rounded"
                  onChange={(e) => updateItem(index, { get_quantity: e.target.value })}
                />
              </div>
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-600 mb-1">Item Details</label>
                <textarea
                  disabled={item.submitted}
                  value={item.item_details}
                  rows={3}
                  className="w-full px-3 py-2 border rounded"
                  onChange={(e) => updateItem(index, { item_details: e.target.value })}
                ></textarea>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-600 mb-1">Vendor Image</label>
                <input
                  type="file"
                  disabled={item.submitted}
                  className="w-full"
                  onChange={(e) => updateItem(index, { vendor_image: e.target.files[0] })}
                />
                {item.vendor_image && !item.submitted && (
                  <img src={URL.createObjectURL(item.vendor_image)} className="h-16 mt-2 rounded border" />
                )}

              </div>


            </div>


            {!item.submitted ? (
              <button
                onClick={() => handleAdd(index)}
                disabled={item.isAdding || item.submitted}
                className="mt-3 bg-orange-500 text-white px-6 py-2 rounded hover:bg-orange-600"
              >
               {item.isAdding ? "Adding..." : "Add Item"}
              </button>
            ) : (
              <p className="mt-3 text-green-600 font-medium">✔ Item Added</p>
            )}
          </div>
        ))}

        <button
          onClick={handleFinish}
          className="px-6 py-2 bg-gray-800 text-white rounded hover:bg-gray-900"
        >
          Finish
        </button>
      </div>
    </div>
    </>
  );
};

export default AddItem;
